module.exports = __webpack_public_path__ + "static/img/icon_rjyf_rjfw_yw.fa03a31c.png";